import { useFormik } from "formik";
import * as Yup from "yup";
import swal from "sweetalert";
import { useEffect, useState } from "react";
import { LocaleTraductionItem } from "interfaces/Post";
import { Link, useHistory, RouteComponentProps } from 'react-router-dom';
import { getPostTranslationById, updatePostTranslation } from "data/posts";

const validationSchema = Yup.object().shape({
    title: Yup.string().required(),
    plain_post_content: Yup.string().required(),
    link_post: Yup.string().required(),
    summary_content : Yup.string().required(),
    img_link: Yup.string().nullable()
});

const BACK_URL = '/admin/posts/translations'

interface Props {
    id?: string
}

const EditTranslationPage = ({ match }: RouteComponentProps<Props>) => {

    const history = useHistory();
    const id = match.params.id || '';
    const [edit, setEdit] = useState<boolean>(false);
    const [initialValues, setInitialValues] = useState<LocaleTraductionItem>({ title: '', plain_post_content: '', link_post: '', id: -1, language: '', summary_content: '', img_link: '', state: 0 })

    const handleSubmit = async (values: any) => {
        try {
            await updatePostTranslation(id, values);
            await swal('Afinidata', "Secuencia editada", "success")
            history.push(BACK_URL);
        } catch (err:any) {
            if(err.response.data.name){
                if(err.response.data.name[0] === 'Ensure this field has no more than 100 characters.')
                swal('Afinidata', 'Max. 100 Caracteres', "error");
                return;
            }
            swal('Afinidata', 'Ocurrio un error al guardar, intente de nuevo', "error")
        }
    }

    useEffect(() => {
        let mounted = true;

        if (mounted) {
            if (id) {
                getPostTranslationById(id)
                    .then((resp) => {
                        setInitialValues(resp.data);
                        setEdit(true);
                    })
                    .catch(err => {
                        console.log(err);
                    });
            }
        }

        return () => { mounted = false; }
    }, [id]);

    const formik = useFormik({
        initialValues,
        validationSchema,
        enableReinitialize: true,
        onSubmit: (values,) => {
            handleSubmit(values);
        },
    });

    return (
        <>
            <div className="row">
                <div className="col-12 mx-auto">
                    <div className="card">
                        <div className="card-header">
                            <h4>{edit ? 'Editar' : 'Añadir'} Traducci&oacute;n</h4>
                        </div>
                        <div className="card-body">
                            <form onSubmit={formik.handleSubmit}>
                                <div className="custom-control custom-switch float-right">
                                    <input type="checkbox" 
                                    className="custom-control-input" 
                                    name="state"
                                    checked={formik.values.state === 1}
                                    onChange={(e) => {
                                        formik.setFieldValue('state', e.target.checked ? 1: 0)
                                    }}
                                    onBlur={formik.handleBlur}
                                    id="customSwitch1"/>
                                    <label className="custom-control-label" htmlFor="customSwitch1">Publicado</label>
                                </div>
                                <div className="form-group">
                                    <label htmlFor="">Title</label>
                                    <input type="text" name="title"
                                        className={`form-control ${formik.errors.title && formik.touched.title ? "is-invalid" : ""}`}
                                        value={formik.values.title}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        maxLength={100}
                                    />
                                    {formik.errors.title && formik.touched.title ? (
                                        <div className="invalid-feedback">{formik.errors.title}</div>
                                    ) : null}
                                </div>
                                <div className="form-group">
                                    <label htmlFor="">Summary</label>
                                    <textarea name="summary_content" 
                                        className={`form-control ${
                                            formik.errors.summary_content && formik.touched.summary_content ? "is-invalid" : ""
                                        }`}
                                        value={formik.values.summary_content}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                    ></textarea>
                                    {formik.errors.summary_content && formik.touched.summary_content ? (
                                        <div className="invalid-feedback">{formik.errors.summary_content}</div>
                                    ) : null}
                                </div>
                                <div className="form-group">
                                    <label htmlFor="">Content</label>
                                    <textarea name="plain_post_content" 
                                        className={`form-control ${
                                            formik.errors.plain_post_content && formik.touched.plain_post_content ? "is-invalid" : ""
                                        }`}
                                        rows={10}
                                        value={formik.values.plain_post_content}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                    ></textarea>
                                    {formik.errors.plain_post_content && formik.touched.plain_post_content ? (
                                        <div className="invalid-feedback">{formik.errors.plain_post_content}</div>
                                    ) : null}
                                </div>
                                <div className="form-group">
                                    <label htmlFor="">URL</label>
                                    <input type="text" name="link_post"
                                        className={`form-control ${formik.errors.link_post && formik.touched.link_post ? "is-invalid" : ""}`}
                                        value={formik.values.link_post}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        maxLength={100}
                                    />
                                    {formik.errors.link_post && formik.touched.link_post ? (
                                        <div className="invalid-feedback">{formik.errors.link_post}</div>
                                    ) : null}
                                </div>
                                <div className="form-group">
                                    <label htmlFor="">Image</label>
                                    <input type="text" name="img_link"
                                        className={`form-control ${formik.errors.img_link && formik.touched.img_link ? "is-invalid" : ""}`}
                                        value={formik.values.img_link}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        maxLength={100}
                                    />
                                    {formik.errors.img_link && formik.touched.img_link ? (
                                        <div className="invalid-feedback">{formik.errors.img_link}</div>
                                    ) : null}
                                </div>
                                <div className="form-group">
                                    <div className="row">
                                        <div className="col-md-6 text-left">
                                            <Link to={BACK_URL} className="btn btn-secondary">
                                                <i className="fa fa-arrow-left"></i>
                                                <span className="ml-2">Volver</span>
                                            </Link>
                                        </div>
                                        <div className="col-md-6 text-right">
                                            <button className="btn btn-primary"
                                                type="submit">
                                                <i className="fa fa-save"></i>
                                                {!edit ? (
                                                    <span className="ml-2">Guardar</span>
                                                ) : (
                                                        <span className="ml-2">Actualizar</span>
                                                    )}
                                            </button>
                                        </div>

                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default EditTranslationPage;
